import {
  SiteSchedule,
  AllSiteSchedule,
  CreateSiteScheduleRequest,
  UpdateSiteScheduleRequest,
} from '../models/SiteSchedule';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export class SiteScheduleService {
  static async list(projectId: number, fromIso?: string, toIso?: string): Promise<SiteSchedule[]> {
    const response = await apiClient.get<ApiListResponse<SiteSchedule>>(
      API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.LIST(projectId, fromIso, toIso),
    );
    return unwrapList(response, '일정 목록 조회 실패');
  }

  /**
   * 전체 현장 통합 일정 조회 — 캘린더용.
   * @param mine true 면 작성자(created_by_id == 나) 기준 내 일정만.
   */
  static async listAll(fromIso?: string, toIso?: string, mine?: boolean): Promise<AllSiteSchedule[]> {
    const response = await apiClient.get<ApiListResponse<AllSiteSchedule>>(
      API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.LIST_ALL(fromIso, toIso, mine),
    );
    return unwrapList(response, '전체 일정 조회 실패');
  }

  static async get(id: number): Promise<SiteSchedule> {
    const response = await apiClient.get<ApiItemResponse<SiteSchedule>>(
      API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.GET(id),
    );
    return unwrapItem(response, '일정 조회 실패');
  }

  /**
   * projectId 가 null 이면 어느 현장에도 속하지 않는 공통 메모를 만든다
   * (백엔드가 event_type='memo' 만 그 경로로 받는다).
   */
  static async create(projectId: number | null, data: CreateSiteScheduleRequest): Promise<SiteSchedule> {
    const url =
      projectId == null
        ? API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.CREATE_COMMON
        : API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.CREATE(projectId);
    const response = await apiClient.post<ApiItemResponse<SiteSchedule>>(url, data);
    return unwrapItem(response, '일정 생성 실패');
  }

  static async update(id: number, data: UpdateSiteScheduleRequest): Promise<SiteSchedule> {
    const response = await apiClient.put<ApiItemResponse<SiteSchedule>>(
      API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.UPDATE(id),
      data,
    );
    return unwrapItem(response, '일정 수정 실패');
  }

  static async delete(id: number): Promise<void> {
    const response = await apiClient.delete<ApiOkResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.SCHEDULES.DELETE(id),
    );
    ensureOk(response, '일정 삭제 실패');
  }
}
